import { useState, useEffect } from 'react';
import { maintenanceState } from '@/lib/maintenance';

export function useMaintenanceMode() {
  const [state, setState] = useState(maintenanceState.getState);

  useEffect(() => {
    return maintenanceState.subscribe((isActive, message) => {
      setState({ isActive, message });
    });
  }, []);

  return state;
}
